<template lang="pug">
v-main
  v-app-bar(color="#D42A2A", dense, dark, fixed, clipped-left, app)
    router-link(to="/login" style=" color: #ffffff; font-size:24px") i-Memo
  v-container
    v-card(style="padding: 1rem; border-radius: 0")
      div
        p(style="font-weight: 400; font-size:24px; margin-bottom:0") Contact Admin Business Unit
        p(style="font-weight: 400; font-size:16px; color: #555555; margin-top: 0.2rem") Find your business unit admin and contact via email or whatsapp.

    v-card(style="padding: 1rem; border-radius: 0; padding-bottom: 0")
      .pb-1
        
        div(style="display: flex")

          v-text-field.pt-0(
            outlined
            :class="{ wrongSearch: wrongSearch}"
            class="textboxes"
            v-model="searchBUText",
            label="Search Business Unit",
            required,
            @keyup.enter="getData"
            hint="Minimum 5 character"
            
          )
            template(
              v-slot:append
              style="margin:0 !Important"
            )
              v-btn(
                style="background: white; box-shadow: none; min-width: 50px; width: 50px; height: 50px",
                @click="getData"
              )
                v-icon fas fa-search
      
    v-card(style="padding: 1rem; border-radius: 0")
      p(
          v-show="buContactData.length != 0 || !dataFound"
          style="font-weight:600; font-size:16px; color:#555555"
        ) Result: 
      v-card.card-contact(
        elevation="0",
        v-show="buContactData.length == 0 && dataFound",
        style="margin: 0; min-width=320px; background:#fff !important", 
      ) 
        div(style="margin: auto; width: 50%; padding: 1rem;")
          p(style="text-align: center")
            v-icon(style="font-size: 59px;") fas fa-search
          p(style="text-align: center; font-size:16px; color: #667085") Please search your business unit
      v-card.card-contact(
        elevation="0",
        v-show="buContactData.length == 0 && !dataFound",
        style="margin: 0; min-width=320px; background:#fff !important", 
      )
        div(style="margin: auto; width: 50%; padding: 1rem;")
          p(style="text-align: center")
            v-icon(style="font-size: 59px;") fa-duotone fa-address-book
          p(style="font-weight:600; font-size:16px ;margin:0;text-align: center; font-size:16px; color: #000") No data available
          p(style="font-weight:400; font-size:14px ;text-align: center; font-size:16px; color: #667085") Please try again with a different keyword. 
      v-card.card-contact(
          elevation="0",
          v-for="data in buContactData",
          :key="data.id"
          
        )
          .title-contact {{ data.business_unit.bu_name }}
          .subtitle-contact.pb-1 Contact us via the link below

          .mt-6(v-for="admin in data.admin")
            v-btn.elevation-0.pa-4.mr-3.text-lowercase(
              rounded,
              color="primary",
              dark,
              :href="`https://mail.google.com/mail/?view=cm&fs=1&to=${admin.email}&su=${subject}&body=${bodyEmail}`",
              target="_blank"
            ) 
              v-icon.mr-2 email
              | {{ admin.email }}

            v-btn.elevation-0.pa-4(
              v-if="admin.msisdn",
              rounded,
              color="green",
              dark,
              :href="`https://wa.me/${admin.msisdn}?text=${bodyWhatsApp}`",
              target="_blank"
            ) 
              img.mr-2(src="../assets/ic_whatsapp.svg")
              | {{ admin.msisdn }}
  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>
    
    <script>
import axios from "axios";
export default {
  name: "Contact",
  data() {
    return {
      wrongSearch: false,
      dataFound: true,
      searchBUText: "",
      subject: "Question Memo",
      bodyEmail:
        "Hi Admin,%0D%0A%0D%0AI need your help for iMemo TechConnect%0D%0A%0D%0AThanks",
      bodyWhatsApp: "Hi Admin,%0A%0AI need your help for iMemo TechConnect",
      users: [],
      overlay: false,

      buContactData: [],
    };
  },
  methods: {
    getData() {
      this.buContactData = [];
      this.wrongSearch = false;
      if (this.searchBUText.length >= 5) {
        this.overlay = true;
        axios
          .get(
            `${process.env.VUE_APP_API}/business-unit/bu-contact?bu_name=${this.searchBUText}`
          )
          .then((res) => {
            this.overlay = false;
            if (res.data.data.length > 0) {
              this.buContactData = res.data.data;
              this.dataFound = true;
            } else this.dataFound = false;
          })
          .catch((err) => {
            console.log(err);
            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
            this.loading = false;
          });
      } else this.wrongSearch = true;
    },
  },
  watch: {
    searchBUText: {
      handler: function () {
        if (this.searchBUText.length >= 5) this.wrongSearch = false;
      },
      deep: true,
    },
  },
};
</script>
    
    <style>
.v-toolbar__content {
  box-shadow: none;
}

.contact-padding {
  padding: 2rem;
}

.card-contact-first {
  margin: 1.5rem;
  background: #f7f7f7 !important;
}

.card-contact {
  background: #f7f7f7 !important;
  padding: 2rem;
  margin: 1.5rem;
}

.title-contact {
  font-size: 24px;
  color: #121212;
  font-weight: 500;
}

.subtitle-contact {
  font-size: 16px;
  color: #555555;
  margin-top: 0.4rem;
}

.img-contact {
  height: 160px;
  width: auto;
}
.textboxes div div div.v-input__append-inner {
  margin-top: 2px !important;
}

.textboxes div .v-text-field__details {
  margin: 0px !important;
}

.wrongSearch fieldset {
  color: red !important;
}

.wrongSearch label {
  color: red !important;
}

.wrongSearch div div .primary--text {
  color: red !important;
}

.wrongSearch div div input {
  color: red !important;
}

.wrongSearch div .v-text-field__details div div {
  color: red;
}
</style>